import React from 'react';
import './PropertyTypeModal.css';

const PropertyTypeModal = ({ isOpen, onClose, onSelectStayProperty, onSelectMeetingRoom }) => {
  if (!isOpen) return null;

  return (
    <div className="property-type-modal-overlay" onClick={onClose}>
      <div className="property-type-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2 className="modal-title">Choose Property Type</h2>
          <button className="modal-close-btn" onClick={onClose}>
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <p className="modal-subtitle">Select the type of property you want to add</p>

        <div className="property-cards-grid">
          {/* Stay Property Card */}
          <div className="property-card" onClick={onSelectStayProperty}>
            <div className="card-icon stay-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
            </div>
            <h3 className="card-title">Stay Property</h3>
            <p className="card-description">
              Add a place for guests to stay such as a hotel, homestay, villa, or apartment. 
              Suitable for overnight stays, tourists, families, and travelers.
            </p>
            <div className="card-features">
              <span className="feature-tag">Hotels</span>
              <span className="feature-tag">Homestays</span>
              <span className="feature-tag">Villas</span>
              <span className="feature-tag">Apartments</span>
            </div>
            <button className="card-select-btn">
              Select Stay Property
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          </div>

          {/* Meeting Room Card */}
          <div className="property-card" onClick={onSelectMeetingRoom}>
            <div className="card-icon meeting-icon">
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
            </div>
            <h3 className="card-title">Meeting Room</h3>
            <p className="card-description">
              Add a space for office meetings such as conference rooms, board rooms, or office cabins. 
              Suitable for team meetings, discussions, and corporate use.
            </p>
            <div className="card-features">
              <span className="feature-tag">Conference Rooms</span>
              <span className="feature-tag">Board Rooms</span>
              <span className="feature-tag">Office Cabins</span>
            </div>
            <button className="card-select-btn">
              Select Meeting Room
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PropertyTypeModal;
